const CustomHeading = ({ title, discription, header, }) => {
    return (
        <>
            <div className="flex align-items-center justify-content-between mb-2 gap-3 capitalize">
                {title && <h1 className="text-4xl karla font-bold m-0">{title}</h1>}
                {header && header}
            </div>
            {discription && <p className="text-xl karla text-gray-500">{discription}</p>}
        </>
    )
}

export default CustomHeading